// extracted by mini-css-extract-plugin
export default {"Header__Section":"Terms_Header__Section__2oTSJ","Terms__Page__Section":"Terms_Terms__Page__Section__pESFX","Page__Title":"Terms_Page__Title__RASue"};